import { FAQS } from '../constants/content';

export default function Faq() {
  return (
    <section className="fm-section" id="faq">
      <div className="fm-container">
        <div className="fm-sec-head fm-sec-head--center">
          <p className="fm-kicker">FAQ</p>
          <h2 className="fm-sec-title">Frequently asked questions</h2>
          <p className="fm-sec-lead">
            Answers about products, delivery, upgrades, and support.
          </p>
        </div>
        <div className="fm-faq-list fm-faq">
          {FAQS.map((item) => (
            <details key={item.q}>
              <summary>{item.q}</summary>
              <p>{item.a}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
